export default __webpack_public_path__ + "static/juice3-69fc6054a125fbeee34cbb13a7c0a118.png";